import { helper } from '@ember/component/helper';
import { htmlSafe } from '@ember/template';

import { escapeRegExp, generateWordsArray } from 'webapp/utils/common';
import { escapeHtml } from 'webapp/utils/html';

export const highlightResult = function (
	_params: void[],
	hash: { text?: string; match?: string | string[] },
) {
	const text = hash.text || '';
	let match = hash.match || [];

	if (!match.length || !text) {
		return text;
	}

	// in case match is string instead of array
	if (!Array.isArray(match)) {
		match = generateWordsArray(match);
	}

	const words = match.filter((item) => item && text.toLowerCase().includes(item.toLowerCase()));

	if (!words.length) {
		return text;
	}

	const regex = new RegExp(`(${words.map(escapeRegExp).join('|')})`, 'ig');
	const highlightedString = text
		.split(regex)
		.map((part, index) =>
			index % 2 ? `<span class="highlight">${escapeHtml(part)}</span>` : escapeHtml(part),
		)
		.join('');

	return htmlSafe(highlightedString);
};

const highlightResultHelper = helper(highlightResult);

export default highlightResultHelper;
